import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { AnimalRecordDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useGetAnimalRecordsList(animalId: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<AnimalRecordDto[], Error>({
    queryKey: ['getAnimalRecordsList', farmId, animalId],
    queryFn: () => animalController.getAnimalRecordsList(farmId!, animalId),
    enabled: !!farmId && !!animalId,
    staleTime: 0
  })
}
